<table *ngIf="_table" class="table-responsive table-md w-100">
  <tbody>
    <tr *ngFor="let attribute of _table.attributes">
      <td class="d-none d-lg-table-cell">
        <strong> {{ attribute.key_01 }} </strong>
      </td>

      <td>
        <span class="responsive-title"> {{ attribute.key_01 }}: </span>

        {{ attribute.value_01 }}
      </td>

      <td class="d-none d-lg-table-cell">
        <strong> {{ attribute.key_02 }} </strong>
      </td>

      <td>
        @if (attribute.key_02) {
          <span class="responsive-title"> {{ attribute.key_02 }}: </span>

          {{ attribute.value_02 }}
        }
      </td>
    </tr>
  </tbody>
</table>
